/**
 * Validates a value is required
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name required
 * @memberof combinators
 */
async function validate(value, context) {
  return Promise.resolve(value !== undefined && value !== null && value !== '' ? null : 'not-specified');
}

module.exports = validate;